import { AlertsManagementFilterKey, AlertsManagementFilterModel } from '../domain/alertsManagementFilterModel';
import { useFilter, useSetFilter } from '../../filter';

export const useAlertsManagementListFilter = () => {
  return useFilter(
    AlertsManagementFilterKey,
    'alertsManagementFilter',
    (filter: string) => new AlertsManagementFilterModel(filter),
    true
  );
};

export const useSetAlertsManagementListFilter = () => {
  return useSetFilter(AlertsManagementFilterKey, 'alertsManagementFilter', true);
};
